import { Box, Button, lighten, styled, Typography } from '@mui/material';

export const DashboardEmployeeStyled = styled(Box)(({ theme }) => ({
  height: '100%',
  width: '100%',
  display: 'flex',
  color: '#303C42',
  fontSize: '14px',
  [theme.breakpoints.down(1000)]: {
    flexDirection: 'column',
  },
}));

export const EmployeeRightSideContainer = styled(Box)(({ theme }) => ({
  backgroundColor: '#71B790',
  borderRadius: '0px 10px 10px 0px',
  display: 'flex',
  padding: '10px 10px 10px 20px',
  justifyContent: 'space-between',
  width: '50%',
  [theme.breakpoints.down(1000)]: {
    display: 'none',
  },
}));

export const EmployeeDownSideContainer = styled(Box)(({ theme }) => ({
  display: 'none',
  [theme.breakpoints.down(1000)]: {
    backgroundColor: '#71B790',
    borderRadius: '0px 0px 10px 10px',
    width: '100%',
    display: 'flex',
    padding: '10px 10px 10px 20px',
    justifyContent: 'space-evenly',
    height: '100px',
    alignItems: 'center',
  },
}));

export const EmployeeLeftSideContainer = styled(Box)(({ theme }) => ({
  backgroundColor: '#DBEDE3',
  display: 'flex',
  flexDirection: 'column',
  borderRadius: '10px 0px 0px 10px',
  justifyContent: 'space-between',
  padding: '10px',
  color: '#008C15',
  width: '50%',
  [theme.breakpoints.down(1000)]: {
    borderRadius: '10px 10px 0px 0px',
    width: '100%',
  },
}));

export const ReadyTitle = styled(Typography)(({ theme }) => ({
  height: '20%',
  fontSize: '0.85rem',
  color: lighten(theme.palette.primary.main, 0.6),
  fontWeight: 'bold',
  [theme.breakpoints.down(845)]: {
    fontSize: '0.75rem',
  },
}));

export const InvitedTitle = styled(Typography)(({ theme }) => ({
  height: '20%',
  fontSize: '0.85rem',
  color: theme.palette.secondary.main,
  fontWeight: 'bold',
  [theme.breakpoints.down(845)]: {
    fontSize: '0.75rem',
  },
}));

export const DeployedTitle = styled(Typography)(({ theme }) => ({
  height: '20%',
  fontSize: '0.85rem',
  color: theme.palette.primary.main,
  fontWeight: 'bold',
  [theme.breakpoints.down(845)]: {
    fontSize: '0.75rem',
  },
}));

export const DashboardEmployeeActionButtonsContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-evenly',
  alignItems: 'center',
  padding: '10px 30px 10px 15px',
  width: '55%',
  [theme.breakpoints.down(1300)]: {
    width: '100%',
  },
  [theme.breakpoints.down(1000)]: {
    width: '100%',
    padding: '10px',
  },
}));

export const DashboardEmployeeActions = styled(Box)(() => ({
  height: '45%',
  display: 'flex',
  padding: '10px',
}));

export const DashboardEmployeeAvatarContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-evenly',
  alignItems: 'center',
  width: '45%',
  [theme.breakpoints.down(1000)]: {
    display: 'none',
  },
}));

export const DashboardEmployeeNumbers = styled(Box)(() => ({
  height: '40%',
  display: 'flex',
  boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.03)',
  paddingBottom: '2px',
  justifyContent: 'space-evenly',
}));

export const DeployedEmployeesNumberStyled = styled(Box)(({ theme }) => ({
  color: theme.palette.primary.main,
  fontSize: '40px',
  fontWeight: 'bold',
}));

export const EmployeeNumberContainerStyled = styled(Box)(() => ({
  padding: '10px',
  width: '33%',
  display: 'flex',
  justifyContent: 'space-between',
  flexDirection: 'column',
}));

export const GoToEmployeesButtonStyled = styled(Button)(({ theme }) => ({
  fontSize: '14px',
  fontWeight: 'bold',
  textTransform: 'none',
  [theme.breakpoints.down(690)]: {
    fontSize: '12px',
  },
}));

export const InvitedEmployeesNumberStyled = styled(Box)(({ theme }) => ({
  color: theme.palette.secondary.main,
  fontSize: '40px',
  fontWeight: 'bold',
}));

export const ReadyEmployeesNumberStyled = styled(Box)(({ theme }) => ({
  color: lighten(theme.palette.primary.main, 0.6),
  fontSize: '40px',
  fontWeight: 'bold',
}));
